module.exports = __webpack_public_path__ + "img/teacher4_yijian.2e4ea462.png";